import { DataGrid, mergeSx, type DataGridProps } from '@shared/components';

export default function BaseAdminProctorList(props: Readonly<DataGridProps>) {
  const { sx: sxProp, ...restProps } = props;

  return (
    <DataGrid
      columnHeaderHeight={48}
      rowHeight={48}
      disableColumnMenu
      sx={mergeSx(
        (theme) => ({
          '--DataGrid-overlayHeight': '584px',
          borderRadius: theme.shape.rounded(0),
          bgcolor: theme.palette.background.paper,
          '.MuiDataGrid-columnHeaders': {
            bgcolor: theme.palette.grey[100],
            borderColor: theme.palette.grey[300],
          },
          '.MuiDataGrid-columnHeader': {
            px: theme.spacing(3),
          },
          '& .MuiDataGrid-row .MuiDataGrid-cell': {
            alignItems: 'center',
            display: 'flex',
            p: theme.spacing(3),
          },
          '& .MuiDataGrid-cell, & .MuiDataGrid-row': {
            borderBottom: '1px solid',
            borderColor: theme.palette.grey[300],
          },
          '> .MuiDivider-root': {
            mt: '-1px',
            borderColor: theme.palette.grey[300],
          },
          '> .MuiBox-root': {
            p: theme.spacing(3, 4),
            '& .MuiToolbar-root': {
              minHeight: 'unset',
              height: 'unset',
              '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                m: 0,
              },
              '& .MuiTablePagination-actions': {
                ml: theme.spacing(1),
                '> button': {
                  p: theme.spacing(1),
                },
              },
            },
          },
        }),
        sxProp,
      )}
      {...restProps}
    />
  );
}
